import { getUserAccount, isTestAccount } from '../../../../configuration';
import type { RootState } from '../../../../configuration/setup/store';

const TERMINATE_CONTRACT_NOW_PRODUCTION_ACCOUNT_IDS = new Set([
    // MAN Truck & Bus Schweiz AG
    '1cd8d1f1-2ee6-41d1-98f6-b7f80c0103e1',
    // MAN Truck&Bus Iberia
    '7283d2d7-88f3-46ee-828e-01ee81d7f2b7',
    // MTBI Logistica
    '521e6a84-3aff-44b8-9c2d-a969bcdc2cb9',
    // MTIB TOP USED
    '78b0dbf0-efe6-4d3f-aa23-359a9df642e7',
    // MAN Truck & BUS UK LTD
    'a8ade106-59f4-4d7d-822f-790adcf1de89',
    // MAN T&B UK - ServiceCare
    '519d5f67-622d-417d-b60c-b8008a7d5332',
    // MAN TopUsed UK
    'ec0b6485-dc59-42a8-8350-7151825448d0',
    // MAN TRUCK & BUS Commerce
    '3d8eac7c-d6f4-422e-90bc-a6fa7778e9f0',
    // MAN FRANCE VUL
    '69c8fdf4-caf1-45eb-bf1a-bd0e20ce3b07',
    // MAN Truck & bus Cars et Bus
    '8f5549a5-d167-46e3-9d91-37ba0f255be6',
    // MAN FRANCE STOCK
    'ff1a135a-2af3-45a7-9ac2-731f8ded6343',
    // MAN Truck & Bus Vertrieb Österreich GesmbH
    '1cea77ad-5ce2-4452-b0af-6cae14ab5f5f',
]);

export const canTerminateContractNow = (state: RootState) =>
    isTestAccount(state) || TERMINATE_CONTRACT_NOW_PRODUCTION_ACCOUNT_IDS.has(getUserAccount(state) ?? '');
